<template>
    <DCard padding>
        <DTable
            :fields="[
                {key: 'id', label: __('products.dnsTemplate.index.table.headers.id'), sorter: false, filter: false},
                {key: 'name', label: __('products.dnsTemplate.index.table.headers.name'), sorter: false, filter: false},
                {key: 'is_default', label: __('products.dnsTemplate.index.table.headers.isDefault'), sorter: false, filter: false},
                {key: 'actions', label: __('messages.actions.actions'), sorter: false, filter: false}
            ]"
            :items="tableItems"
            class="mb-0"
        >
            <template #id="{item}">
                <td style="width: 70px;">
                    {{ item.id }}
                </td>
            </template>
            <template #name="{item}">
                <td style="justify-content: center;">
                    {{ item.name }}
                </td>
            </template>
            <template #is_default="{item}">
                <td style="width: 110px;">
                    <DBadge :color="item.is_default ? 'success' : 'secondary'">
                        {{ item.is_default ? __('products.dnsTemplate.index.table.values.default.yes') : __('products.dnsTemplate.index.table.values.default.no') }}
                    </DBadge>
                </td>
            </template>
            <template #actions="{item}">
                <td style="width: 350px">
                    <div style="display: flex; align-items: center; grid-gap: 10px;">
                        <DButton
                            :id="`make_default_${item.id}`"
                            icon="check-circle-outline"
                            :label="__('messages.actions.makeDefault')"
                            mini
                            :disabled="item.is_default === 1"
                            @click="$inertia.put($route('products.dns-templates.make-default', {dns_template: item.id}))"
                        />
                        <DButton
                            :id="`view_${item.id}`"
                            icon="eye"
                            mini
                            @click="$inertia.get($route('products.dns-templates.show', {dns_template: item.id}))"
                        />
                        <DButton
                            v-if="userPermissions.includes('dns_templates.edit')"
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            mini
                            @click="$inertia.get($route('products.dns-templates.edit', {dns_template: item.id}))"
                        />
                        <DButton
                            v-if="userPermissions.includes('dns_templates.delete')"
                            :id="`btn-delete-${item.id}`"
                            icon="trash-can-outline"
                            color="danger"
                            mini
                            :disabled="item.is_default === 1 || item.products.length > 0 || isInLoadingState"
                            @click="deleteDNSTemplate(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="dnsTemplates.last_page > 1"
            :active-page="dnsTemplates.current_page"
            :pages="dnsTemplates.last_page"
            align="center"
            @update:activePage="changePage"
        />

        <DFabs>
            <DFab
                v-if="userPermissions.includes('dns_templates.create')"
                id="btn-add"
                icon="plus"
                :label="__('products.dnsTemplate.index.addButton')"
                @click="$inertia.get($route('products.dns-templates.create'))"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('products.products.index.deleteConfirmation.title')"
            :message="__('products.products.index.deleteConfirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script>
export default {
    name: 'DNSTemplateIndex',
    props: {
        dnsTemplates: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            deleteCallBack: () => { return {} }
        }
    },
    computed: {
        tableItems () {
            const items = []

            this.dnsTemplates.data.forEach(dnsTemplate => {
                dnsTemplate.actions = ''
                items.push(dnsTemplate)
            })

            return items
        },
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        deleteDNSTemplate (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('products.dns-templates.destroy', id))
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        changePage (page) {
            const query = {}

            if (page > 1) {
                query.page = page
            }

            this.$inertia.get(this.$route('products.dns-templates.index'), query)
        }
    }
}
</script>
